/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2016, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../util/EdgeIterator'
], (EdgeIterator) => {

	'use strict';

	return class CrosstabEdgeIterator extends EdgeIterator {

		constructor() {
			super(...arguments);
			this.EdgeIterator = CrosstabEdgeIterator;
		}

		createLeafNodeInfo(descendant_or_self, value, currentEdge, ancestors, maxLevel) {
			const nodeInfo = {
				descendant_or_self,
				descendant_or_self_without_measures: currentEdge.isMeasure ? [] : descendant_or_self,
				index: this.currentKeyIndex,
				value,
				type: currentEdge.type,
				isSummary: currentEdge.isSummary,
				isOverallSummary: currentEdge.isOverallSummary,
				isLeafNode: true,
				ancestor_or_self: (!ancestors) ? [value] : ancestors.concat(value),
				nestLevel: currentEdge.level,
				isMeasure: currentEdge.isMeasure,
				summaryOf: currentEdge.summaryOf,
				formatSpec: currentEdge.formatSpec
			};

			if (!currentEdge.isSummary) {
				nodeInfo.cellIdx = currentEdge.cellIdx;
			}

			this.rollupSummariesOfDescendents(nodeInfo, value, maxLevel);

			return nodeInfo;
		}

		createNodeInfo(descendant_or_self, value, currentEdge, childNode, maxLevel) {
			const nodeInfo = {
				descendant_or_self,
				descendant_or_self_without_measures: currentEdge.isMeasure ? childNode.descendant_or_self_without_measures : descendant_or_self.concat(childNode.descendant_or_self_without_measures),
				index: this.numberOfLeafNodes - 1,
				value,
				type: currentEdge.type,
				isSummary: currentEdge.isSummary || childNode.isSummary,
				isOverallSummary: currentEdge.isOverallSummary || childNode.isOverallSummary,
				hasMeasureChildren: currentEdge.hasMeasureChildren,
				noOfChildren: this.subIterator.keys.length,
				hasLeafNode: (childNode.isLeafNode || childNode.hasLeafNode),
				ancestor_or_self: this.ancestor_or_self,
				nestLevel: currentEdge.level,
				isMeasure: currentEdge.isMeasure,
				summaryOf: currentEdge.summaryOf || childNode.summaryOf,
				subCategory: childNode,
				formatSpec: currentEdge.formatSpec
			};

			this.rollupSummariesOfDescendents(nodeInfo, value, maxLevel, childNode);
			nodeInfo.descendant_or_self = nodeInfo.descendant_or_self.concat(childNode.descendant_or_self);

			if (!currentEdge.isSummary) {
				nodeInfo.cellIdx = currentEdge.cellIdx;
			}
			return nodeInfo;
		}
	};
});